import { NgClass } from "@angular/common";
import { Component, EventEmitter, inject, Input, Output } from "@angular/core";

import { EditDialogComponent } from "./components/edit-dialog/edit-dialog.component";
import { MonthDetailsComponent } from "./components/month-details/month-details.component";
import { HistoryRecord, PlanRecord } from "@shared/models";
import { MinutesToTimePipe, DateIntToStringPipe } from "@shared/pipes";
import { getContractualMonth } from "@shared/functions/date.functions";
import { convertToMinutes } from "@shared/functions";
import { GlobalService } from "@shared/services";

type HistoryColumns = "PROJ" | "IMAX";

@Component({
  selector: "app-table",
  standalone: true,
  imports: [NgClass, EditDialogComponent, MonthDetailsComponent, MinutesToTimePipe, DateIntToStringPipe],
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent {
  globalService = inject(GlobalService);
  @Input() data: HistoryRecord[] = [];
  @Output() onHistorySave = new EventEmitter<HistoryRecord>();
  @Output() onRefreshHistory = new EventEmitter<number>();

  editVisible = false;
  monthDetailsVisible = false;

  selectedRow: HistoryRecord | null = null;

  get displayedColumns(): HistoryColumns[] {
    return ["PROJ", "IMAX"];
  }

  getCellValue(row: HistoryRecord, column: HistoryColumns): number {
    const historyColumnMapping: Record<HistoryColumns, keyof HistoryRecord> = {
      PROJ: "projMinutes",
      IMAX: "imaxMinutes",
    };

    const historyKey = historyColumnMapping[column];
    if (historyKey && historyKey in row) {
      return (row as HistoryRecord)[historyKey] as number;
    }
    return 0;
  }

  handleClick(row: HistoryRecord): void {
    this.selectedRow = row;
    this.editVisible = true;
  }

  handleFocus(): void {
    this.globalService.activePlanUnsaved.set(true);
  }

  highlightChanges(): void {}

  onHistorySaveHandler(record: HistoryRecord): void {
    this.onHistorySave.emit(record);
  }

  onRefreshHistoryHandler(id: number): void {
    this.onRefreshHistory.emit(id);
  }
}
